/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Edit_PlaceholderInputs */

const en_landing_studio_edit_placeholder = /** @type {(inputs: Landing_Studio_Edit_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Change the label text to "Late Bloom", same typeface`)
};

const zh_landing_studio_edit_placeholder = /** @type {(inputs: Landing_Studio_Edit_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：把标签文字改成 "Late Bloom"，字体保持不变`)
};

/**
* | output |
* | --- |
* | "e.g. Change the label text to \"Late Bloom\", same typeface" |
*
* @param {Landing_Studio_Edit_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_edit_placeholder = /** @type {((inputs?: Landing_Studio_Edit_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Edit_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_edit_placeholder(inputs)
	return zh_landing_studio_edit_placeholder(inputs)
});
export { landing_studio_edit_placeholder as "landing.studio.edit_placeholder" }